if (!customElements.get('aleisha-recently-viewed')) {
  customElements.define(
    'aleisha-recently-viewed',
    class AleishaRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.loadProducts();
      }

      async loadProducts() {
        const grid = this.querySelector('[data-recently-viewed-grid]');
        if (!grid) return;

        let viewedProducts = [];
        try {
          viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
        } catch (error) {
          this.hidden = true;
          return;
        }

        const currentProductId = String(this.dataset.currentProductId || '');
        const maxProducts = Number(this.dataset.maxProducts || 4);
        const productIds = viewedProducts
          .map(String)
          .filter((id) => id && id !== currentProductId)
          .slice(0, maxProducts);

        if (!productIds.length) {
          this.hidden = true;
          return;
        }

        try {
          const url = new URL('/search', window.location.origin);
          url.searchParams.set('view', 'recently-viewed');
          url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
          url.searchParams.set('resources[type]', 'product');

          const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Recently viewed request failed: ${response.status}`);

          const markup = await response.text();
          const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
          const fetchedCards = Array.from(documentFragment.querySelectorAll('[data-recent-product-id]'));
          const cardsById = new Map(fetchedCards.map((card) => [card.dataset.recentProductId, card]));
          const orderedCards = productIds.map((id) => cardsById.get(id)).filter(Boolean);

          if (!orderedCards.length) {
            this.hidden = true;
            return;
          }

          grid.replaceChildren(...orderedCards);
          this.hidden = false;
        } catch (error) {
          this.hidden = true;
        }
      }
    }
  );
}
